<template>
	<form class='form' @submit.stop.prevent="submit">
		<h4>Результаты взаимодействия ДЛХ с правоохранительными и надзорными органами</h4>
		<div class="row">
			<div class="col-md-3 col">
				<span class="bold">Федеральный округ</span>
			</div>
			<div class="col-md-3 col">
				<span class="bold">Субъект РФ</span>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3 col">
				<select class='form-control my-control' v-model='fo_id' @change='onChangeFO' :disabled='!fo_options || !fo_options.length'>
					<option v-for='option in fo_options' :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
			<div class="col-md-3 col">
				<select class='form-control my-control' v-model='region_id' @change='onChangeRegion' :disabled='!fo_id || !region_options || !region_options.length'>
					<option v-for='option in region_options' :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3 col">
				<span class="bold">Лесничество</span>
			</div>
			<div class="col-md-3 col">
				<span class="bold">№ актов ЛПО</span>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3 col">
				<select class='form-control my-control' v-model='forestry_id' :disabled='!region_id || !forestry_options || !forestry_options.length' @change='onChangeForestry'>
					<option v-for='option in forestry_options' :value='option.id'>
						{{ option.name }}
					</option>
				</select>
			</div>
			<div class="col-md-3 col">
				<button type='button' class='form-control my-control' :title='selectedActsIds' :disabled='!forestry_id || !acts_short || !acts_short.length' @click='openActsModal'>
					{{ selectedActsIdsShort }}
				</button>
			</div>
		</div>

		<hr>
		<div class='form_wrap' :class="{'disabled': form_disabled}">
			<div class="row">
				<div class="col-sm-12" style="overflow: hidden;">
					<div class='table_head_wrap'>
						<table class='acts_table place_table__top'>
							<thead>
								<tr>
									<th class="form_td">№ акта ЛПО</th>
									<th class="form_td">Участковое лесничество</th>
									<th class="form_td">Урочище</th>
									<th class="form_td">Квартал</th>
									<th class="form_td">Выдел</th>
									<th class="form_td">Лп. выдел</th>
									<th class="form_td">МЗЛ</th>
									<th class="form_td">S МЗЛ</th>
									<th :width='scroll_width'></th>
								</tr>
								<tr>
									<th>1</th>
									<th>2</th>
									<th>3</th>
									<th>4</th>
									<th>5</th>
									<th>6</th>
									<th>7</th>
									<th>8</th>
									<th :width='scroll_width'></th>
								</tr>
							</thead>
						</table>
					</div>
					<div class='table_body_wrap'>
						<table class='acts_table place_table__bottom'>
							<tbody>
								<tr v-for='line in acts_full'>
									<td v-if='line.flag' class='form_td' :rowspan="line.count">
										{{ line.num }}
									</td>
									<td v-if='line.flag_lf' class='form_td' :rowspan="line.count_lf">
										{{ line.localforestry }}
									</td>
									<td v-if='line.flag_sf' class='form_td' :rowspan="line.count_sf">
										{{ line.subforestry }}
									</td>
									<td class='form_td'>
										{{ line.area }}
									</td>
									<td class='form_td'>
										{{ line.section }}
									</td>
									<td class='form_td'>
										{{ line.section_lp }}
									</td>
									<td class='form_td'>
										{{ line.mzl }}
									</td>
									<td class='form_td'>
										{{ line.s_mzl }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="row" style='margin-top: 45px;'>
				<!-- <div class="col-md-2"></div> -->
				<div class="col-md-2 text-right" style='line-height: 24px;'>
					<span class='bold'>Наименование правоохранительного органа*</span>
				</div>
				<div class="col-md-10">
					<textarea v-model='f_118' rows='2' class='form-control' @input='checkInput("f_118")' style='margin-top: 5px;' :disabled='form_disabled' :class='fields_correct.f_118'></textarea>
				</div>
			</div>

			<h5 style='margin-top: 20px;'>
				Реквизиты исходящего письма из ДЛХ в правоохранительные органы
			</h5>

			<div class="row">
				<div class="col-sm-12">
					<table class='dateTable'>
						<thead>
							<tr>
								<th style='width: 15%;'>Дата*</th>
								<th style='width: 15%;'>Номер*</th>
								<th style='width: 70%;'>Краткое содержание письма, комментарии*</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<datepicker
										v-model='f_119'
										@input='checkInput("f_119")'
										format='yyyy-MM-dd'
										:disabled='readonly || form_disabled'
										class='table-control'
										:class='fields_correct.f_119'
									></datepicker>
								</td>
								<td>
									<input class='form-control my-control table-control' v-model='f_120' @input='checkInput("f_120")' :disabled='form_disabled' :class='fields_correct.f_120'>
								</td>
								<td>
									<input class='form-control my-control table-control' v-model='f_121' @input='checkInput("f_121")' :disabled='form_disabled' :class='fields_correct.f_121'>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="row" style='margin-top: 25px;'>
				<!-- <div class="col-md-2"></div> -->
				<div class="col-md-2 text-right" style='line-height: 24px;'>
					<span class='bold'>Результаты рассмотрения направленных ДЛХ материалов</span>
				</div>
				<div class="col-md-10">
					<textarea rows='2' class='form-control' style='margin-top: 5px;' :disabled='form_disabled' v-model='f_122'></textarea>
				</div>
			</div>

			<div class="row" style='margin: 5px;'></div>
		</div>
		<hr>

		<div class='btnPanel'>
			<!-- <b-button class='clearBtn' @click.prevent='clearForm' variant='secondary'>Очистить</b-button> -->
			<input type='button' class='btn btn-secondary' @click.prevent="close" value='Отмена' :disabled="readonly">
			<!-- <input type='button' class='btn btn-primary' @click='submit' value='Сохранить' :disabled="readonly"></input> -->
			<button class='btn btn-primary' @click.prevent='submit' :disabled="submit_disabled || readonly">
				<i class='fa fa-spinner fa-spin' v-if='submit_disabled'></i>
				{{ submit_disabled ? 'Сохранение' : 'Сохранить' }}
			</button>

		</div>

		<modal title='' v-model="showActsModal" medium :backdrop='false'>
			<div slot="modal-header" class="modal-header">
				<h4 class="modal-title">Выбор актов</h4>
			</div>
			<div slot="modal-body" class="modal-body">
				<ul class='act_nums'>
					<li v-for='(act, index) in acts_short' :key='act.main_id' :class='checkIsActInGroup(index)'>
						<checkbox type='info' v-model='act.checked' @input='(e)=>changeActCheckbox(e,index)'>{{act.act_num}}</checkbox>
					</li>
				</ul>
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-primary" @click='cancelActsModal'>Отмена</button>
				<button type="button" class="btn btn-primary" @click='okActsModal'>Ок</button>
			</div>
		</modal>

	</form>
</template>

<script>
	import router from '../../router'
	import auth from '../../auth'
	import moment from 'moment';

	import { datepicker, modal, checkbox } from 'vue-strap'
 
	import { EventBus } from '../../lib/EventBus'

	import {DB} from './../../constants'

	const GET_FO = 'get_fo.php'
	const GET_REGIONS = 'region_list.php'
	const GET_FORESTRIES = 'forestrie_list.php'
	const GET_ACTS_BY_FORESTRY = 'get_acts_by_forestry.php'
	const GET_SUPERVISORY_ACTS = 'get_supervisory_acts.php'
	const GET_SUPERVISON_INFO = 'get_supervisory_info.php'
	const GROUP_JSON = 'group_json.php'

	const TIMEOUT = 120000 //2 минуты
	const MAX_BUTTON_TEXT_LENGTH = 40

	export default {
		name: 'supervisionForm',
		data: function () {
			return {
				scroll_width: 17,
				readonly: false,

				submit_disabled: false,
				firstInitDone: false,

				fo_id: 0,
				region_id: 0,
				forestry_id: 0,
				f_118: '',
				f_119: '',
				f_120: '',
				f_121: '',
				f_122: '',

				fo_options: [],
				region_options: [],
				forestry_options: [],

				showActsModal: false,
				acts_short: [],
				acts_full: [],
				selected_acts: [],

				saved_acts_short: [],
				counter: 0,
				supervisory_id: null,

				fields_correct: {
					f_118: '',
					f_119: '',
					f_120: '',
					f_121: ''
				},

				fields: ['f_118', 'f_119', 'f_120', 'f_121', 'f_122'],
				fields_to_check: ['f_118', 'f_119', 'f_120', 'f_121']
			}
		},
		components: {
			datepicker, modal, checkbox
		},
		computed: {
			selectedActsIdsShort () {
				const selected_nums = this.selected_acts.map(e => {return e.act_num})
				const str = selected_nums.join(', ')
				if (str.length > MAX_BUTTON_TEXT_LENGTH)
					return  str.substr(0, MAX_BUTTON_TEXT_LENGTH) + '...'
				else
					return str
			},
			selectedActsIds () {
				const selected_nums = this.selected_acts.map(e => {return e.act_num})
				const str = selected_nums.join(', ')
				return str
			},
			form_disabled () {
				return !Boolean(this.acts_full.length > 0)
			}
		},
		watch: {
		},
		methods: {
			checkInput (name) {
				if((!this[name] || !this[name].length) && !this.form_disabled)
					this.fields_correct[name] = 'field-error'
				else
					this.fields_correct[name] = ''
			},
			floatConvert (number) {
			    return +(parseFloat(number).toPrecision(12))
			},
			filterInput (e) {
				e.target.value = e.target.value.replace(/[,-]/g, ".").replace(/[^\.\d]/g, "")
			},
			checkFields () {
				for(let field of this.fields_to_check) {
					this.checkInput(field)
				}

				for (let field of this.fields_to_check) {
					if(!this[field] || !this[field].length)
						return false
				}

				return true
			},
			onChangeFO () {
				this.region_id = 0
				this.forestry_id = 0
				this.acts_short = []
				this.acts_full = []
				this.selected_acts = []
				this.clearFields()

				fetch(DB + GET_REGIONS + '?id=' + this.fo_id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					if (res) {
						this.region_options = [{id:0, name:''}, ...res]

					}

				})
				.catch(err => console.log(err))
			},
			onChangeRegion () {
				this.forestry_id = 0
				this.acts_short = []
				this.acts_full = []
				this.selected_acts = []
				this.clearFields()

				fetch(DB + GET_FORESTRIES + '?id=' + this.region_id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					if (res) {
						this.forestry_options = [{id:0, name:''}, ...res]
					}
				})
				.catch(err => console.log(err))
			},
			onChangeForestry () {
				this.acts_short = []
				this.acts_full = []
				this.selected_acts = []
				this.clearFields()

				if(this.forestry_id) {
					this.loadActsShort()
				}
			},
			changeActCheckbox (e, index) {
				if(this.counter > 0)
				{
					this.counter--
					return false
				}

				this.counter = 0
				if(this.acts_short[index].supervisory_id) {
					for(let act_id in this.acts_short) {
						if(this.acts_short[act_id].supervisory_id == this.acts_short[index].supervisory_id)
						{
							if(this.acts_short[act_id].checked != e)
							{
								this.acts_short[act_id].checked = e
								this.counter++
							}
						}
						else {
							if(this.acts_short[act_id].checked != false && this.acts_short[act_id].checked != undefined)
							{
								this.acts_short[act_id].checked = false
								this.counter++
							}
							
						}
					}
				} 
				else {
					for(let act in this.acts_short) {
						if(this.acts_short[act].supervisory_id) {
							if(this.acts_short[act].checked != false && this.acts_short[act].checked != undefined)
							{
								this.acts_short[act].checked = false
								this.counter++
							}
							
						}
					}
				}

				this.$forceUpdate()
			},
			checkIsActInGroup (i) {
				if(
					this.acts_short[i].supervisory_id 
					&& !this.acts_short[i - 1]
				) {
					return 'first_act_in_group ' + this.acts_short[i].class
				}

				if(
					this.acts_short[i].supervisory_id 
					&& this.acts_short[i - 1] 
					&& this.acts_short[i - 1].supervisory_id 
					&& this.acts_short[i - 1].supervisory_id != this.acts_short[i].supervisory_id
				) {
					return 'first_act_in_group ' + this.acts_short[i].class
				}

				if(this.acts_short[i].supervisory_id)
					return 'act_in_group ' + this.acts_short[i].class
			},
			loadActsShort (saveSelectedActs = false) {
				let selected_ids = []
				if(saveSelectedActs) {
					selected_ids = this.selected_acts.map(e => {return e.main_id})
				} else {
					this.selected_acts = []
				}

				fetch(DB + GET_ACTS_BY_FORESTRY + '?id=' + this.forestry_id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					this.acts_short = res || []
					let current_class = 'odd'
					for(let act in this.acts_short) {
						if(selected_ids.includes(this.acts_short[act].main_id))
							this.acts_short[act].checked = true

						if(this.acts_short[act].supervisory_id) {
							if(
								this.acts_short[act].supervisory_id 
								&& !this.acts_short[act - 1]
							) {
								this.acts_short[act].class = current_class
							}
							if(
								this.acts_short[act].supervisory_id 
								&& this.acts_short[act - 1] 
								&& this.acts_short[act - 1].supervisory_id 
								&& this.acts_short[act - 1].supervisory_id != this.acts_short[act].supervisory_id
							) {
								if(current_class == 'odd')
									current_class = 'even'
								else
									current_class = 'odd'

								this.acts_short[act].class = current_class
							}

							if(this.acts_short[act].supervisory_id)
								this.acts_short[act].class = current_class

						}
					}
					if (this.$route.params.id && !this.firstInitDone) {
						// let acts = this.$parent.supervisory_obj.act_nums;
						// acts = acts.split(',');
						// console.log(acts);

						// let act_num = acts[0];

						const supervisory_id = this.$route.params.id;

						let current_act = null;

						this.acts_short.forEach((act, i) => {
							if (act.supervisory_id === supervisory_id) {
								current_act = i;
							}
						});
						this.openActsModal();
						this.changeActCheckbox(true, current_act);
						
						this.okActsModal();

						this.firstInitDone = true;

						this.counter = 0;
					}
				})
				.catch(err => console.log(err))
			},
			loadSupervisionInfo (id) {
				fetch(DB + GET_SUPERVISON_INFO+ '?id=' + id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					for(let field in res[0]) {
						if(field !== 'f_117') {
							this[field] = res[0][field]
						}
					}
				})
			},
			clearFields () {
				for (let field of this.fields) {
					this[field] = ''
				}
			},
			openActsModal () {
				this.saved_acts_short = JSON.parse(JSON.stringify(this.acts_short))
				this.showActsModal = true
			},
			cancelActsModal () {
				this.showActsModal = false

				//wait for end of animation
				setTimeout(() => {
					this.acts_short = JSON.parse(JSON.stringify(this.saved_acts_short))	
				}, 500)
			},
			okActsModal () {
				this.showActsModal = false
				this.selected_acts = []
				const selected_ids = []
				let supervisory_id = null
				for(let act of this.acts_short) {
					if(act.checked)
					{
						selected_ids.push(act.main_id)
						this.selected_acts.push({ main_id: act.main_id, act_num: act.act_num })
						if(act.supervisory_id)
							supervisory_id = act.supervisory_id
					}
				}
				this.supervisory_id = supervisory_id

				if(this.supervisory_id == null)
					this.clearFields()

				if(this.selected_acts.length) {
					this.loadSupervisionInfo(supervisory_id)
					fetch(DB + GET_SUPERVISORY_ACTS + '?ids={' + selected_ids.join(',') + '}',{credentials: 'include'})
					.then(res => res.json())
					.then(res => {
						let temp_lines = []
						let prev_id = -1
						let prev_localforestry_id = -1
						let prev_subforestry_id = -1

						for (let i = 0; i < res.length; i++) {
							let act = {}

							let start_fo = i
							while (i > 0 && res[start_fo - 1].act_id === res[i].act_id && start_fo > 1) {
								start_fo--
							}

							let curr = start_fo
							while (curr < res.length && res[curr].act_id === res[start_fo].act_id ) {
								curr++
							}
							act.count = curr - start_fo

							if (res[i].act_id === prev_id) {
								act.flag = false
							}
							else {
								act.flag = true
							}
							//////////////////

							let start_lf = i
							while (i > 0 && res[start_lf - 1].localforestry_id === res[i].localforestry_id && start_lf > 1 && res[start_lf - 1].act_id === res[i].act_id) {
								start_lf--
							}

							let curr_lf = start_lf
							while (curr_lf < res.length && res[curr_lf].act_id === res[start_lf].act_id && res[curr_lf].localforestry_id === res[i].localforestry_id) {
								curr_lf++
							}
							act.count_lf = curr_lf - start_lf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_lf = false
							}
							else {
								act.flag_lf = true
							}

							////////////////////////
							let start_sf = i
							while (i > 0 && res[start_sf - 1].localforestry_id === res[i].localforestry_id && start_sf > 1 && res[start_sf - 1].act_id === res[i].act_id) {
								start_sf--
							}

							let curr_sf = start_sf
							while (curr_sf < res.length && res[curr_sf].act_id === res[start_sf].act_id && res[curr_sf].localforestry_id === res[i].localforestry_id) {
								curr_sf++
							}
							act.count_sf = curr_sf - start_sf

							if (res[i].act_id === prev_id && prev_localforestry_id === res[i].localforestry_id) {
								act.flag_sf = false
							}
							else {
								act.flag_sf = true
							}
							////////////////////////
							

							prev_id = res[i].act_id
							prev_localforestry_id = res[i].localforestry_id
							prev_subforestry_id = res[i].subforestry_id

							Object.assign(act, res[i])

							temp_lines.push(act)
						}
						this.acts_full = temp_lines

					})
				} else {
					this.acts_full = []
				}
			},
			submit () {
				this.submit_disabled = true

				let obj = [{}]
				if(this.supervisory_id) {//update
					obj[0].u = []
					obj[0].u.push({})
					obj[0].u[0].tab_id = 4
					obj[0].u[0].f_v = {}
					obj[0].u[0].f_v.f_c = this.supervisory_id

					for(let field of this.fields) {
						obj[0].u[obj[0].u.length - 1].f_v[field] = this[field]
					}
					//const selected_nums = this.selected_acts.map(e => {return e.main_id})
					//const str = selected_nums.join(', ')

				} else {//insert
					obj[0].i = {}
					obj[0].i.tab = []
					obj[0].i.tab.push({})
					obj[0].i.tab[0].tab_id = 4
					obj[0].i.tab[0].f_v = {}

					for(let field of this.fields) {
						obj[0].i.tab[0].f_v[field] = this[field]
					}
					const selected_ids = this.selected_acts.map(e => {return e.main_id})
					const str = '{' + selected_ids.join(', ') + '}'
					obj[0].i.tab[0].f_v.f_117 = str
				}

				const submit_act_info = () => {
					let form = new FormData()
					form.append('json', JSON.stringify(obj))

					let first_check_result = null
					let second_check_result = null
					
					const first_check = setTimeout(() => {
						if(first_check_result === null)
						{
							first_check_result = false
							alert('Во время сохранения акта произошла ошибка. Повторите попытку позже.')
							this.submit_disabled = false

						}
					}, TIMEOUT)

					fetch(DB + GROUP_JSON, {
						credentials: 'include',
						method: 'post',
						body: form
					})
					.then(result => result.json())
					.then(result => {
						if(first_check_result === null)
						{
							first_check_result = true
							clearTimeout(first_check)

							if(result[0].code === '0') {
								alert('Акт сохранен')
								this.loadActsShort(true)
								//router.replace('/main')
							}
							else {
								alert('Во время сохранения акта произошла ошибка. На Ваш компьютер будет сохранён файл с отладочной информацией. Перешлите данный файл вместе со скриншотом экрана разработчикам для выявления и устранения ошибки.')
								this.download(JSON.stringify(obj) + '_' + result[0].name, 'edit_' + Date() + '.json', 'text/json')
							}
							this.submit_disabled = false
						}
					})
					.catch(err => {
						console.log(err)
						this.submit_disabled = false
					})
				}
				if (this.checkFields()) {
					if(document.querySelector('.field-error') !== null)
					{
						const b = confirm('Часть полей может содержать некорректные данные. Вы уверены, что хотите продолжить?')
						if(b)
						{
							submit_act_info()
						} else
						{
							this.submit_disabled = false
						}
					} else {
						submit_act_info()
					}				
				}
				else {
					alert('Поля, отмеченные звёздочкой, обязательны к заполнению.')
					this.submit_disabled = false
				}

				//console.log(this.prepareToDelete)
			},
			download(content, fileName, contentType) {
			    var a = document.createElement("a");
			    var file = new Blob([content], {type: contentType});
			    a.href = URL.createObjectURL(file);
			    a.download = fileName;
			    var event = document.createEvent("MouseEvents");
		        event.initMouseEvent(
		                "click", true, false, window, 0, 0, 0, 0, 0
		                , false, false, false, false, 0, null
		        );
			    a.dispatchEvent(event);
			},
			close () {
				if(history.length > 1)
					history.go(-1)
				else
					router.replace('/main')
			}
		},
		created () {
			fetch(DB + GET_FO, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				if (res) {
					this.fo_options = res
				}
			})
			.catch(err => console.log(err))

			if (this.$route.params.id && this.$parent.supervisory_obj) {

				const act = this.$parent.supervisory_obj;

				this.fo_id = act.fo_id;
				this.onChangeFO();

				this.region_id = act.region_id;
				this.onChangeRegion();

				this.forestry_id = act.forestry_id;
				this.onChangeForestry();
			}
		},
		beforeDestroy () {

		},
		watch: {
			
		},
		updated() {

		}
	}

	function commaToPeriod(str) {
		return str.replace(/,/g, ".")
	}
</script>

<style scoped>

	div.datepicker {
		width: 100%;
	}

/* div.datepicker.table-control > input.form-control {
	border: none !important;
	height: 24px;
	margin: 0px;
	display: inline-table !important;
} */

div.datepicker.table-control > input.error {
	background-color: lightcoral;
}

td.error {
	background-color: lightcoral;
}

.my-control {
	padding-left: 5px !important;
	padding-top: 0px !important;
	padding-bottom: 0px !important;
	margin-bottom: 5px;
	height: 24px;
	display: inline-table !important;
	font-size: 12px !important;
}

select.my-control:not([size]):not([multiple]) {
	height: 24px;
}

.table-control {
	height: 24px;
	width: 100%;
	margin: 0px;
	border: none !important;
}

select.form-control:not([size]):not([multiple]) {
	height: 24px !important;
}

/* .grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
} */

.clearBtn {
	margin-right: 10px;
}

.left_input_wrapper {
	height: 30px;
    line-height: 24px;
}

.acts_table {
	width: 100%;
	table-layout: fixed;
}

.acts_table td.form_td {
	font-size: 12px;
}

h5 {
	font-size: 18px;
	margin-top: 0px;
	text-align: center;
}

.form_wrap.disabled {
	cursor: not-allowed;
    background-color: #eee;
    margin: -10px;
    padding: 10px;
}

.form_wrap.disabled input,
.form_wrap.disabled textarea {
	/*cursor: not-allowed;
    background-color: rgba(0,0,0,0.2);*/
}

.act_nums {
	max-height: 550px;
	overflow-y: scroll;
	margin-left: 5px;
	padding-left: 0;
}


.act_nums li {
	list-style-type: none;
	border-top: 1px solid #bfd3ffaa;
}

.act_nums li:last-child {
	border-bottom: 1px solid #bfd3ffaa;
}

.act_nums li label {
	font-size: 110%;
	height: 35px;
    display: flex;
    align-items: center;
    margin-top: 2px;
    margin-bottom: 2px;
}

.table_body_wrap {
	max-height: 50vh !important;
}

textarea.form-control {
	min-height: 50px;
    overflow: hidden;
}

.act_in_group {
	border-top: none !important;
}

.act_in_group,
.first_act_in_group {
	/*background: #f6f6f6;*/
} 

.act_in_group label,
.first_act_in_group label {
	height: 28px !important;
	margin-top: 0 !important;
	margin-bottom: 0 !important;
}

li.even {
	background: #eafff5;
}

li.odd {
	background: #eaf7ff;
}

.table-control.field-error {
	box-shadow: inset 0px 0px 1px 1px rgba(255,0,0,0.7);
}
</style>

<style>
.act_nums span.dropdown-toggle {
	top: calc(50% - 8px) !important;
}

div.field-error input.datepicker-input {
	box-shadow: inset 0px 0px 1px 1px rgba(255,0,0,0.7);
}
</style>


// WEBPACK FOOTER //
// supervisionForm.vue?4963de5f